import type { AddressParams } from '@restore/dynamic-forms';
import { DocumentServiceAddress } from './types';
import { convertBoolean } from './convertBoolean';

export const address = (
  addressProperties: DocumentServiceAddress | undefined
): AddressParams | undefined => {
  if (!addressProperties) {
    return undefined;
  }

  const { addr_line1, addr_line2, city, state, postal, country } = addressProperties;
  const parsed: AddressParams = {
    addr_line1: addr_line1
      ? { ...addr_line1, required: convertBoolean(addr_line1.required) }
      : undefined,
    addr_line2: addr_line2
      ? { ...addr_line2, required: convertBoolean(addr_line2.required) }
      : undefined,
    city: city ? { ...city, required: convertBoolean(city.required) } : undefined,
    state: state ? { ...state, required: convertBoolean(state.required) } : undefined,
    postal: postal ? { ...postal, required: convertBoolean(postal.required) } : undefined,
    country: country ? { ...country, required: convertBoolean(country.required) } : undefined,
  };

  return parsed;
};
